/* Kinetic Chrome — optional auto-fit for product photos.

   OFF BY DEFAULT. The photo you upload is shown exactly as you framed it; this
   script does not touch it. That is deliberate: auto-fitting is only useful
   while source files have wildly different amounts of empty space around the
   product, and the moment you start exporting consistent files yourself it does
   the opposite - it overrides your framing and crops your work.

   To switch it on for a section, set --kc-fit-target on .kc-buy-img from that
   section's custom CSS box, e.g.

       .kc-buy-img { --kc-fit-target: 0.92; }

   With it on, every photo is scaled so the product's content box occupies that
   fraction of the frame - in and out, no exceptions - and the slide is painted
   with the photo's own border colour so a scale below 1 never shows an edge.
   Content is found via the alpha channel for cut-outs, otherwise by colour
   distance from the median of the whole border ring. */
(function () {
  var MAX    = 2.2;           /* never zoom in further than this */
  var MIN    = 0.6;           /* never shrink further than this */
  var THRESH = 18;            /* colour distance from the border colour */
  var SAMPLE = 360;           /* measure at this size, in px, for speed */

  function median(a) { a.sort(function (p, q) { return p - q; }); return a[a.length >> 1]; }

  /* Returns { fw, fh, cx, cy, bg } as fractions of the image, or null. */
  function measure(probe) {
    var s  = Math.min(1, SAMPLE / Math.max(probe.naturalWidth, probe.naturalHeight));
    var cw = Math.max(1, Math.round(probe.naturalWidth  * s));
    var ch = Math.max(1, Math.round(probe.naturalHeight * s));
    var cv = document.createElement('canvas'); cv.width = cw; cv.height = ch;
    var g  = cv.getContext('2d', { willReadFrequently: true });
    g.drawImage(probe, 0, 0, cw, ch);
    var d = g.getImageData(0, 0, cw, ch).data;

    /* A transparent cut-out tells us exactly where the product is. */
    var hasAlpha = false;
    for (var a = 3; a < d.length; a += 4) { if (d[a] < 250) { hasAlpha = true; break; } }

    /* Otherwise: the median of the whole border ring, not four corner pixels —
       one stray highlight in a corner used to throw the whole measurement off. */
    var rs = [], gs = [], bs = [], i;
    function edge(x, y) { i = (y * cw + x) * 4; rs.push(d[i]); gs.push(d[i + 1]); bs.push(d[i + 2]); }
    for (var x = 0; x < cw; x++) { edge(x, 0); edge(x, ch - 1); }
    for (var y = 0; y < ch; y++) { edge(0, y); edge(cw - 1, y); }
    var bg = [median(rs), median(gs), median(bs)];

    var minX = cw, maxX = -1, minY = ch, maxY = -1;
    for (var py = 0; py < ch; py++) {
      for (var px = 0; px < cw; px++) {
        var k = (py * cw + px) * 4, on;
        if (hasAlpha) {
          on = d[k + 3] > 24;
        } else {
          on = Math.abs(d[k] - bg[0]) + Math.abs(d[k + 1] - bg[1]) + Math.abs(d[k + 2] - bg[2]) > THRESH;
        }
        if (!on) continue;
        if (px < minX) minX = px;
        if (px > maxX) maxX = px;
        if (py < minY) minY = py;
        if (py > maxY) maxY = py;
      }
    }
    if (maxX < 0) return null;

    return {
      fw: (maxX - minX + 1) / cw,
      fh: (maxY - minY + 1) / ch,
      cx: (minX + maxX + 1) / 2 / cw,
      cy: (minY + maxY + 1) / 2 / ch,
      bg: 'rgb(' + bg[0] + ',' + bg[1] + ',' + bg[2] + ')',
      cutout: hasAlpha
    };
  }

  /* null = not opted in, so leave the upload alone. */
  function targetFor(img) {
    var host = img.closest('.kc-buy-img') || img;
    var v = parseFloat(getComputedStyle(host).getPropertyValue('--kc-fit-target'));
    return (v > 0.3 && v <= 1) ? v : null;
  }

  function fit(img) {
    if (img.getAttribute('data-kc-fitted')) return;

    var TARGET = targetFor(img);
    if (TARGET === null) {          /* not opted in: your upload, untouched */
      img.setAttribute('data-kc-fitted', 'off');
      return;
    }

    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      var m = null;
      try { m = measure(probe); } catch (e) { m = null; }   /* tainted canvas */
      if (!m) { img.setAttribute('data-kc-fitted', 'skipped'); return; }
      img.setAttribute('data-kc-fitted', '1');

      var scale = TARGET / Math.max(m.fw, m.fh);
      if (scale > MAX) scale = MAX;
      if (scale < MIN) scale = MIN;

      /* The photo's own background behind it, so a scale below 1 shows more of
         the same colour instead of a visible border. */
      var slide = img.parentElement;
      if (slide && !m.cutout) slide.style.background = m.bg;

      var tx = (0.5 - m.cx) * scale * 100;
      var ty = (0.5 - m.cy) * scale * 100;
      img.style.transformOrigin = '50% 50%';
      img.style.transform = 'translate(' + tx.toFixed(2) + '%, ' + ty.toFixed(2) + '%) scale(' + scale.toFixed(3) + ')';
      img.setAttribute('data-kc-fit',
        'inhoud ' + Math.round(m.fw * 100) + '%x' + Math.round(m.fh * 100) +
        '% → zoom ' + scale.toFixed(3) + 'x');
    };
    probe.onerror = function () { img.setAttribute('data-kc-fitted', 'skipped'); };
    probe.src = img.currentSrc || img.src;
  }

  function run() {
    var imgs = document.querySelectorAll('.kc-buy-img .kc-gallery-slide img');
    for (var i = 0; i < imgs.length; i++) fit(imgs[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();

/* Kinetic Chrome — the chrome sweep on the product's name.
   "The Meridian" shines on "Meridian" only, and only twice: the sweep fires when
   the title scrolls into view, repeats once after a short pause, then the class
   is dropped so the heading rests in solid ink instead of looping next to the
   buy button.

   Two sweeps is safe to loop because both ends of the animation are solid ink.
   The gradient is 300% wide and does not repeat: at background-position 0% the
   visible window is the leftmost third (all #0f1729), at 100% the rightmost
   third (also #0f1729). The highlight only lives in the middle third, so it
   passes through and leaves - there is no jump when the second sweep starts. */
(function () {
  var SWEEPS  = 2;            /* how many times the highlight travels across */
  var PAUSE   = 700;          /* ms of rest between the two sweeps */
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function esc(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function sweep(span) {
    var left = SWEEPS;

    function start() {
      /* Removing the class is not enough to replay a CSS animation - the
         browser only restarts it once the element has been reflowed without
         it. Reading offsetWidth forces that reflow. */
      span.classList.remove('is-swept');
      void span.offsetWidth;
      span.classList.add('is-swept');
    }

    span.addEventListener('animationend', function onEnd() {
      left--;
      if (left > 0) {
        setTimeout(start, PAUSE);
        return;
      }
      span.removeEventListener('animationend', onEnd);
      /* Rest in solid ink. The stroke is deliberately left alone here - see
         kc-styles.css - otherwise the letters visibly thin out at this moment. */
      span.classList.remove('kc-glint-once', 'is-swept');
    });

    start();
  }

  function glint() {
    var els = document.querySelectorAll('.kc-product-title');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.getAttribute('data-kc-glint')) continue;
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text) continue;
      el.setAttribute('data-kc-glint', '1');
      if (REDUCED) continue;               /* leave the title exactly as it is */

      var parts = text.split(' ');
      var last = parts.pop();
      var head = parts.length ? esc(parts.join(' ')) + ' ' : '';
      el.innerHTML = head + '<span class="kc-glint-once">' + esc(last) + '</span>';

      var span = el.querySelector('.kc-glint-once');
      if (!span) continue;
      if (!('IntersectionObserver' in window)) { sweep(span); continue; }
      new IntersectionObserver(function (entries, obs) {
        for (var k = 0; k < entries.length; k++) {
          if (!entries[k].isIntersecting) continue;
          obs.disconnect();
          sweep(entries[k].target);
        }
      }, { threshold: 0.6 }).observe(span);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', glint);
  else glint();
  document.addEventListener('shopify:section:load', glint);
})();


/* Kinetic Chrome — "Hoe te gebruiken" als vierde rij in de accordion.

   Waarom zo en niet direct in kc-product-buy.liquid: die sectie is 46KB en
   bevat het complete koopblok inclusief de add-to-cart. Elke aanpassing daar
   betekent dat het hele bestand opnieuw weggeschreven wordt, en dat risico is
   niet in verhouding tot één extra rij. De tekst zelf blijft gewoon door de
   winkelier te bewerken in de sectie "KC Hoe te gebruiken", staat in de
   broncode van de pagina, en valt terug op zijn eigen plek als dit script
   niet draait. */
(function () {
  function gear() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"' +
           ' stroke-linecap="round" stroke-linejoin="round">' +
           '<circle cx="12" cy="12" r="3"></circle><circle cx="12" cy="12" r="7.5"></circle>' +
           '<line x1="12" y1="4.5" x2="12" y2="2.2"></line><line x1="12" y1="19.5" x2="12" y2="21.8"></line>' +
           '<line x1="19.5" y1="12" x2="21.8" y2="12"></line><line x1="4.5" y1="12" x2="2.2" y2="12"></line>' +
           '<line x1="17.3" y1="6.7" x2="18.93" y2="5.07"></line><line x1="6.7" y1="17.3" x2="5.07" y2="18.93"></line>' +
           '<line x1="17.3" y1="17.3" x2="18.93" y2="18.93"></line><line x1="6.7" y1="6.7" x2="5.07" y2="5.07"></line>' +
           '</svg>';
  }
  function chevron() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"' +
           ' stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>';
  }

  function move() {
    var src = document.querySelector('[data-kc-howto]');
    var acc = document.querySelector('.kc-accordion');
    if (!src || !acc || src.hasAttribute('data-kc-howto-moved')) return;

    var body = src.querySelector('.kc-howto-body');
    if (!body) return;

    var item = document.createElement('div');
    item.className = 'kc-accordion-item';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'kc-accordion-header';
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<span class="kc-accordion-icon">' + gear() + '</span>' +
                    '<span class="kc-accordion-label"></span>' +
                    '<span class="kc-accordion-chevron">' + chevron() + '</span>';
    btn.querySelector('.kc-accordion-label').textContent =
      src.getAttribute('data-kc-howto-title') || 'Hoe te gebruiken';

    var content = document.createElement('div');
    content.className = 'kc-accordion-content kc-accordion-rich';
    content.hidden = true;
    while (body.firstChild) content.appendChild(body.firstChild);

    /* De sectie bindt zijn eigen accordion-koppen bij het laden, dus deze rij
       krijgt zijn schakelaar hier - anders zou hij niet opengaan. */
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      content.hidden = open;
    });

    item.appendChild(btn);
    item.appendChild(content);
    acc.appendChild(item);
    src.setAttribute('data-kc-howto-moved', '1');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', move);
  else move();
  document.addEventListener('shopify:section:load', move);
})();
